var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-content" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card" },
      [
        _c("div", { staticClass: "card-header" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-theme",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.openModal("save", "")
                }
              }
            },
            [_vm._v("Nuevo usuario")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "form-group row" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "input-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.search,
                      expression: "search"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "text",
                    placeholder: "Ingrese el nombre del empleado a buscar"
                  },
                  domProps: { value: _vm.search },
                  on: {
                    keyup: function($event) {
                      return _vm.showUsers(1, _vm.search, _vm.checkboxmanual)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.search = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-theme",
                    attrs: { type: "submit" },
                    on: {
                      click: function($event) {
                        return _vm.showUsers(1, _vm.search, _vm.checkboxmanual)
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "icon-fa icon-fa-search" }),
                    _vm._v(" Buscar\n            ")
                  ]
                )
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "custom-control custom-checkbox mb-3" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.checkboxmanual,
                        expression: "checkboxmanual"
                      }
                    ],
                    staticClass: "custom-control-input",
                    attrs: {
                      id: "customControlValidation1",
                      type: "checkbox",
                      required: ""
                    },
                    domProps: {
                      checked: Array.isArray(_vm.checkboxmanual)
                        ? _vm._i(_vm.checkboxmanual, null) > -1
                        : _vm.checkboxmanual
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$a = _vm.checkboxmanual,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.checkboxmanual = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.checkboxmanual = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.checkboxmanual = $$c
                          }
                        },
                        function($event) {
                          return _vm.showUsers(
                            1,
                            _vm.search,
                            _vm.checkboxmanual
                          )
                        }
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _vm.checkboxmanual === false
                    ? _c(
                        "label",
                        {
                          staticClass: "custom-control-label",
                          attrs: { for: "customControlValidation1" }
                        },
                        [
                          _vm._v(
                            "\n              Mostrar datos inactivos\n            "
                          )
                        ]
                      )
                    : _c(
                        "label",
                        {
                          staticClass: "custom-control-label",
                          attrs: { for: "customControlValidation1" }
                        },
                        [
                          _vm._v(
                            "\n              Mostrar datos activos\n            "
                          )
                        ]
                      ),
                  _vm._v(" "),
                  _c("div", { staticClass: "invalid-feedback" }, [
                    _vm._v("Example invalid feedback text")
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("table", { staticClass: "table table-responsive table-hover" }, [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.arrayUsers, function(user) {
                return _c("tr", { key: user.id }, [
                  _c("td", {
                    domProps: { textContent: _vm._s(user.employee.person.name) }
                  }),
                  _vm._v(" "),
                  _c("td", { domProps: { textContent: _vm._s(user.user) } }),
                  _vm._v(" "),
                  _c("td", {
                    domProps: { textContent: _vm._s(user.role.name) }
                  }),
                  _vm._v(" "),
                  _c("td", {
                    domProps: {
                      textContent: _vm._s(user.employee.person.email)
                    }
                  }),
                  _vm._v(" "),
                  _c("td", {
                    domProps: { textContent: _vm._s(user.employee.job) }
                  }),
                  _vm._v(" "),
                  _c("td", {
                    domProps: { textContent: _vm._s(user.employee.place.name) }
                  }),
                  _vm._v(" "),
                  _c("td", [
                    user.state == 1
                      ? _c("span", { staticClass: "btn btn-success btn-sm" }, [
                          _vm._v("Activo")
                        ])
                      : _c("span", { staticClass: "btn btn-danger btn-sm" }, [
                          _vm._v("Desactivado")
                        ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      [
                        _c(
                          "div",
                          {
                            staticClass: "btn-group mr-2",
                            attrs: {
                              role: "group",
                              "aria-label": "First group"
                            }
                          },
                          [
                            _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip.top-center",
                                    value: "Editar",
                                    expression: "'Editar'",
                                    modifiers: { "top-center": true }
                                  }
                                ],
                                staticClass: "btn btn-theme",
                                on: {
                                  click: function($event) {
                                    return _vm.openModal("update", user)
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "icon-fa icon-fa-pencil"
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c("a", { attrs: { href: "" } }),
                            _vm._v(" "),
                            user.state == 1
                              ? _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip.top-center",
                                        value: "Desactivar",
                                        expression: "'Desactivar'",
                                        modifiers: { "top-center": true }
                                      }
                                    ],
                                    staticClass: "btn btn-danger",
                                    attrs: {
                                      href: "#" + user.employee.person.name
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.openModal(
                                          "desactivate",
                                          user
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "icon-fa icon-fa-trash"
                                    })
                                  ]
                                )
                              : _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip.top-center",
                                        value: "Activar",
                                        expression: "'Activar'",
                                        modifiers: { "top-center": true }
                                      }
                                    ],
                                    staticClass: "btn btn-info",
                                    attrs: {
                                      href: "#" + user.employee.person.name
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.openModal("activate", user)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "icon-fa icon-fa-check"
                                    })
                                  ]
                                )
                          ]
                        )
                      ]
                    ],
                    2
                  )
                ])
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _c(
                "ul",
                { staticClass: "pagination pagination-primary m-b-0" },
                [
                  _vm.pagination.current_page > 1
                    ? _c("li", { staticClass: "page-item" }, [
                        _c(
                          "a",
                          {
                            staticClass: "page-link",
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.changePage(
                                  _vm.pagination.current_page - 1,
                                  _vm.search,
                                  _vm.checkboxmanual
                                )
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "icon-fa icon-fa-angle-left"
                            })
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.pagesNumber, function(page) {
                    return _c(
                      "li",
                      {
                        key: page,
                        staticClass: "page-item",
                        class: [page == _vm.isActived ? "active" : ""]
                      },
                      [
                        _c("a", {
                          staticClass: "page-link",
                          attrs: { href: "#" },
                          domProps: { textContent: _vm._s(page) },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.changePage(
                                page,
                                _vm.search,
                                _vm.checkboxmanual
                              )
                            }
                          }
                        })
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.pagination.current_page < _vm.pagination.last_page
                    ? _c("li", { staticClass: "page-item" }, [
                        _c(
                          "a",
                          {
                            staticClass: "page-link",
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.changePage(
                                  _vm.pagination.current_page + 1,
                                  _vm.search,
                                  _vm.checkboxmanual
                                )
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "icon-fa icon-fa-angle-right"
                            })
                          ]
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "sweet-modal",
          {
            ref: "user_modal",
            attrs: {
              title: _vm.modalTitle,
              "hide-close-button": "",
              blocking: ""
            }
          },
          [
            _c("div", { staticClass: "card-body" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", [_vm._v("Empleado")]),
                  _vm._v(" "),
                  _c(
                    "multiselect",
                    {
                      class: { "is-invalid": _vm.$v.employee_id.$error },
                      attrs: {
                        options: _vm.arrayEmployees,
                        "close-on-select": true,
                        "clear-on-select": false,
                        "show-labels": false,
                        placeholder: "Seleccione un empleado",
                        label: "name",
                        "track-by": "id"
                      },
                      model: {
                        value: _vm.employee_id,
                        callback: function($$v) {
                          _vm.employee_id = $$v
                        },
                        expression: "employee_id"
                      }
                    },
                    [
                      _c("template", { slot: "beforeList" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-success btn-lg btn-block",
                            on: {
                              click: function($event) {
                                return _vm.openModal("employee", "")
                              }
                            }
                          },
                          [
                            _vm._v("Nuevo empleado"),
                            _c("i", { staticClass: "icon-fa icon-fa-plus" })
                          ]
                        )
                      ])
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.$v.employee_id.$error
                    ? _c("div", [
                        !_vm.$v.employee_id.required
                          ? _c(
                              "span",
                              { staticClass: "help-block help-block-error" },
                              [_vm._v("El empleado es requerido")]
                            )
                          : _vm._e()
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Nombre de usuario")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.user,
                      expression: "user",
                      modifiers: { trim: true }
                    }
                  ],
                  staticClass: "form-control",
                  class: { "is-invalid": _vm.$v.user.$error },
                  attrs: { placeholder: "Ingrese el nombre de usuario" },
                  domProps: { value: _vm.user },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.user = $event.target.value.trim()
                      },
                      function($event) {
                        return _vm.$v.user.$touch()
                      }
                    ],
                    blur: function($event) {
                      return _vm.$forceUpdate()
                    }
                  }
                }),
                _vm._v(" "),
                _vm.$v.user.$error
                  ? _c("div", [
                      !_vm.$v.user.required
                        ? _c(
                            "span",
                            { staticClass: "help-block help-block-error" },
                            [_vm._v("El usuario es requerido")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.user.minLength
                        ? _c(
                            "span",
                            { staticClass: "help-block help-block-error" },
                            [
                              _vm._v(
                                "\n              El minimo del caracteres es de\n              " +
                                  _vm._s(_vm.$v.user.$params.minLength.min) +
                                  " letras.\n            "
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Contraseña")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.password,
                      expression: "password",
                      modifiers: { trim: true }
                    }
                  ],
                  staticClass: "form-control",
                  class: { "is-invalid": _vm.$v.password.$error },
                  attrs: {
                    type: "password",
                    placeholder: "Ingrese la contraseña"
                  },
                  domProps: { value: _vm.password },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.password = $event.target.value.trim()
                      },
                      function($event) {
                        return _vm.$v.password.$touch()
                      }
                    ],
                    blur: function($event) {
                      return _vm.$forceUpdate()
                    }
                  }
                }),
                _vm._v(" "),
                _vm.$v.password.$error
                  ? _c("div", [
                      !_vm.$v.password.required
                        ? _c(
                            "span",
                            { staticClass: "help-block help-block-error" },
                            [_vm._v("La contraseña es requerida")]
                          )
                        : _vm._e()
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Rol")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.idrole,
                        expression: "idrole",
                        modifiers: { trim: true }
                      }
                    ],
                    staticClass: "form-control",
                    class: { "is-invalid": _vm.$v.idrole.$error },
                    on: {
                      input: function($event) {
                        return _vm.$v.idrole.$touch()
                      },
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.idrole = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  _vm._l(_vm.arrayRoles, function(role) {
                    return _c("option", {
                      key: role.id,
                      domProps: {
                        value: role.id,
                        textContent: _vm._s(role.name)
                      }
                    })
                  }),
                  0
                ),
                _vm._v(" "),
                _vm.$v.idrole.$error
                  ? _c("div", [
                      !_vm.$v.idrole.required
                        ? _c(
                            "span",
                            { staticClass: "help-block help-block-error" },
                            [_vm._v("El rol es requerido")]
                          )
                        : _vm._e()
                    ])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-danger",
                attrs: { slot: "button", type: "button" },
                on: {
                  click: function($event) {
                    return _vm.closeModal()
                  }
                },
                slot: "button"
              },
              [_vm._v("Cancelar")]
            ),
            _vm._v(" "),
            _vm.tipoAccion == 1
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-primary ladda-button",
                    attrs: {
                      slot: "button",
                      type: "button",
                      "data-style": "expand-right"
                    },
                    on: {
                      click: function($event) {
                        return _vm.saveUser()
                      }
                    },
                    slot: "button"
                  },
                  [_vm._v("Guardar")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.tipoAccion == 2
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-primary ladda-button",
                    attrs: {
                      slot: "button",
                      type: "button",
                      "data-style": "expand-right"
                    },
                    on: {
                      click: function($event) {
                        return _vm.updateUser()
                      }
                    },
                    slot: "button"
                  },
                  [_vm._v("Actualizar")]
                )
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "sweet-modal",
          {
            ref: "employee_modal",
            attrs: {
              title: _vm.modalTitleEmployee,
              "hide-close-button": "",
              blocking: ""
            }
          },
          [
            _c(
              "sweet-modal-tab",
              { attrs: { id: "tab1", title: "Datos principales" } },
              [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Nombre")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.name,
                        expression: "name",
                        modifiers: { trim: true }
                      }
                    ],
                    staticClass: "form-control",
                    class: { "is-invalid": _vm.$v.name.$error },
                    attrs: { placeholder: "Ingrese el nombre del empleado" },
                    domProps: { value: _vm.name },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          $event.keyCode !== 39
                        ) {
                          return null
                        }
                        return _vm.$refs.employee_modal.open("tab2")
                      },
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.name = $event.target.value.trim()
                        },
                        function($event) {
                          return _vm.$v.name.$touch()
                        }
                      ],
                      blur: function($event) {
                        return _vm.$forceUpdate()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.$v.name.$error
                    ? _c("div", [
                        !_vm.$v.name.required
                          ? _c(
                              "span",
                              { staticClass: "help-block help-block-error" },
                              [_vm._v("El campo es requerido")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.$v.name.minLength
                          ? _c(
                              "span",
                              { staticClass: "help-block help-block-error" },
                              [
                                _vm._v(
                                  "\n              El minimo del caracteres es de\n              " +
                                    _vm._s(_vm.$v.name.$params.minLength.min) +
                                    " letras.\n            "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Direccion")]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.address,
                        expression: "address",
                        modifiers: { trim: true }
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { placeholder: "Ingrese la dirección" },
                    domProps: { value: _vm.address },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          $event.keyCode !== 39
                        ) {
                          return null
                        }
                        return _vm.$refs.employee_modal.open("tab2")
                      },
                      textarea: function($event) {
                        return _vm.$v.address.$touch()
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.address = $event.target.value.trim()
                      },
                      blur: function($event) {
                        return _vm.$forceUpdate()
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Genero")]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.gender,
                          expression: "gender",
                          modifiers: { trim: true }
                        }
                      ],
                      staticClass: "form-control",
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.gender = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "0" } }, [
                        _vm._v("Seleccione el genero")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "1" } }, [
                        _vm._v("Masculino")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "2" } }, [
                        _vm._v("Femenino")
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [_vm._v("Número")]),
                    _vm._v(" "),
                    _c("masked-input", {
                      staticClass: "form-control",
                      attrs: {
                        mask: [
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          "-",
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/
                        ],
                        placeholder: "Ingrese el número de teléfono"
                      },
                      on: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            $event.keyCode !== 39
                          ) {
                            return null
                          }
                          return _vm.$refs.employee_modal.open("tab2")
                        }
                      },
                      model: {
                        value: _vm.number,
                        callback: function($$v) {
                          _vm.number =
                            typeof $$v === "string" ? $$v.trim() : $$v
                        },
                        expression: "number"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [_vm._v("CUI")]),
                    _vm._v(" "),
                    _c("masked-input", {
                      staticClass: "form-control",
                      attrs: {
                        mask: [
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          " ",
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          " ",
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/
                        ],
                        placeholder:
                          "Ingrese el número de identificación personal"
                      },
                      on: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            $event.keyCode !== 39
                          ) {
                            return null
                          }
                          return _vm.$refs.employee_modal.open("tab2")
                        }
                      },
                      model: {
                        value: _vm.cui,
                        callback: function($$v) {
                          _vm.cui = typeof $$v === "string" ? $$v.trim() : $$v
                        },
                        expression: "cui"
                      }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "sweet-modal-tab",
              { attrs: { id: "tab2", title: "Datos de trabajo" } },
              [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Correo")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.email,
                        expression: "email",
                        modifiers: { trim: true }
                      }
                    ],
                    staticClass: "form-control",
                    class: { "is-invalid": _vm.$v.email.$error },
                    attrs: {
                      type: "email",
                      placeholder: "Ingrese el correo electrónico"
                    },
                    domProps: { value: _vm.email },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.email = $event.target.value.trim()
                        },
                        function($event) {
                          return _vm.$v.email.$touch()
                        }
                      ],
                      blur: function($event) {
                        return _vm.$forceUpdate()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.$v.email.$error
                    ? _c("div", [
                        !_vm.$v.email.correo
                          ? _c(
                              "span",
                              { staticClass: "help-block help-block-error" },
                              [_vm._v("El correo electrónico es invalido")]
                            )
                          : _vm._e()
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Trabajo")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.job,
                        expression: "job",
                        modifiers: { trim: true }
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { placeholder: "Ingrese el puesto de trabajo" },
                    domProps: { value: _vm.job },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.job = $event.target.value.trim()
                      },
                      blur: function($event) {
                        return _vm.$forceUpdate()
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Lugar de trabajo")]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.idplace,
                          expression: "idplace",
                          modifiers: { trim: true }
                        }
                      ],
                      staticClass: "form-control",
                      class: { "is-invalid": _vm.$v.idplace.$error },
                      on: {
                        input: function($event) {
                          return _vm.$v.idplace.$touch()
                        },
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.idplace = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    _vm._l(_vm.arrayPlaces, function(place) {
                      return _c("option", {
                        key: place.id,
                        domProps: {
                          value: place.id,
                          textContent: _vm._s(place.name)
                        }
                      })
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm.$v.idplace.$error
                    ? _c("div", [
                        !_vm.$v.idplace.required
                          ? _c(
                              "span",
                              { staticClass: "help-block help-block-error" },
                              [_vm._v("El campo es requerido")]
                            )
                          : _vm._e()
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [_vm._v("Fecha de contratación")]),
                    _vm._v(" "),
                    _c("datepicker", {
                      class: { "is-invalid": _vm.$v.hiring_date.$error },
                      attrs: {
                        format: _vm.customFormatter,
                        language: _vm.es,
                        "input-class": "form-control",
                        placeholder: "Ingrese la fecha de contratación"
                      },
                      on: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            $event.keyCode !== 13
                          ) {
                            return null
                          }
                          return _vm.saveEmployee.apply(null, arguments)
                        },
                        input: function($event) {
                          return _vm.$v.hiring_date.$touch()
                        }
                      },
                      model: {
                        value: _vm.hiring_date,
                        callback: function($$v) {
                          _vm.hiring_date =
                            typeof $$v === "string" ? $$v.trim() : $$v
                        },
                        expression: "hiring_date"
                      }
                    }),
                    _vm._v(" "),
                    _vm.$v.hiring_date.$error
                      ? _c("div", [
                          !_vm.$v.hiring_date.required
                            ? _c(
                                "span",
                                { staticClass: "help-block help-block-error" },
                                [
                                  _vm._v(
                                    "La fecha de contratación es requerida"
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-danger",
                attrs: { slot: "button", type: "button" },
                on: {
                  click: function($event) {
                    _vm.$refs.employee_modal.close(), (_vm.tipoAccion = 1)
                  }
                },
                slot: "button"
              },
              [_vm._v("Cancelar")]
            ),
            _vm._v(" "),
            _vm.tipoAccion == 5
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-primary ladda-button",
                    attrs: {
                      slot: "button",
                      type: "button",
                      "data-style": "expand-right"
                    },
                    on: {
                      click: function($event) {
                        return _vm.saveEmployee()
                      }
                    },
                    slot: "button"
                  },
                  [_vm._v("Guardar")]
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "sweet-modal",
          {
            ref: "state_modal",
            attrs: { icon: "info", "hide-close-button": "", blocking: "" }
          },
          [
            _vm._v("\n      " + _vm._s(_vm.modalTitleState) + "\n      "),
            _c(
              "button",
              {
                staticClass: "btn btn-info",
                attrs: { slot: "button", type: "button" },
                on: {
                  click: function($event) {
                    return _vm.$refs.state_modal.close()
                  }
                },
                slot: "button"
              },
              [_vm._v("No")]
            ),
            _vm._v(" "),
            _vm.tipoAccion == 3
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-danger",
                    attrs: { slot: "button", type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.desactivateUser()
                      }
                    },
                    slot: "button"
                  },
                  [_vm._v("Si")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.tipoAccion == 4
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-success",
                    attrs: { slot: "button", type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.activateUser()
                      }
                    },
                    slot: "button"
                  },
                  [_vm._v("Si")]
                )
              : _vm._e()
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("h3", { staticClass: "page-title" }, [_vm._v("Usuarios")]),
      _vm._v(" "),
      _c("ol", { staticClass: "breadcrumb" }, [
        _c("li", { staticClass: "breadcrumb-item" }, [
          _c("a", { attrs: { href: "/" } }, [_vm._v("Home")])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "breadcrumb-item" }, [
          _c("a", { attrs: { href: "#" } }, [_vm._v("Personal")])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "breadcrumb-item active" }, [
          _vm._v("Usuarios")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Nombre")]),
        _vm._v(" "),
        _c("th", [_vm._v("Usuario")]),
        _vm._v(" "),
        _c("th", [_vm._v("Rol")]),
        _vm._v(" "),
        _c("th", [_vm._v("Correo")]),
        _vm._v(" "),
        _c("th", [_vm._v("Trabajo")]),
        _vm._v(" "),
        _c("th", [_vm._v("Lugar de trabajo")]),
        _vm._v(" "),
        _c("th", [_vm._v("Estado")]),
        _vm._v(" "),
        _c("th", [_vm._v("Opciones")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19a11b9b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19a11b9b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/admin/persons/User.vue
// module id = 687
// module chunks = 0